// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1eVjM","noInteraction":"EventWrapper_noInteraction__15wTm"};